import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

// PATCH request to update a product
export const updateProduct = createAsyncThunk(
  "products/updateProduct",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.patch(
        `${apiUrl}/Products/${id}/update/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      
      // Return both id and updated data for proper state update
      return {
        id: id,
        data: response.data
      };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Generate AI description for a product
export const generateAIDescription = createAsyncThunk(
  "products/generateAIDescription",
  async (name, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${apiUrl}/Products/GenerateDescription/`,
        { name },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      return response.data.description;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const productSlice = createSlice({
  name: "products",
  initialState: {
    products: [],
    selectedProduct: null, // Add selectedProduct to store
    loading: false,
    error: null,
    aiDescriptionLoading: false,
  },
  reducers: {
    // Add action to update selectedProduct
    updateSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        state.loading = false;
        const { id, data } = action.payload;
        
        // Update in products array
        const index = state.products.findIndex(
          (product) => product.id === id
        );
        if (index !== -1) {
          state.products[index] = data;
        }
        
        // Update selectedProduct if it's the same product
        if (state.selectedProduct && state.selectedProduct.id === id) {
          state.selectedProduct = data;
        }
      })
      .addCase(updateProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(generateAIDescription.pending, (state) => {
        state.aiDescriptionLoading = true;
      })
      .addCase(generateAIDescription.fulfilled, (state, action) => {
        state.aiDescriptionLoading = false;
      })
      .addCase(generateAIDescription.rejected, (state, action) => {
        state.aiDescriptionLoading = false;
        state.error = action.payload;
      });
  },
});

export const { updateSelectedProduct } = productSlice.actions;
export default productSlice.reducer;